/* eslint-disable max-lines */
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import btnAuthority from '@/modules/mdm/btnAuthority.js';

export const config = {
    name: 'organizationLog',
    searchFields: [
        {
            name: '同步日期',
            value: 'syncTimeFixed',
            type: 'time',
            time: 'daterange',
            format: 'yyyy-MM-dd',
            startPlaceholder: '同步日期从',
            endPlaceholder: '同步日期到',
            isFixed: true,
            span: 6
        },
        {
            name: '变更类型',
            value: 'changeType',
            type: 'select',
            optionNum: 'LCRM_USER_CHANGE_TYPE',
            isFixed: true,
            span: 4
        },
        {
            name: '处理状态',
            value: 'processStatus',
            type: 'select',
            optionNum: 'LCRM_USER_PROCESSED_STATUS',
            isFixed: true,
            span: 4
        },
        {
            name: '用户状态',
            value: 'enableFlag',
            type: 'select',
            optionNum: 'LCRM_USER_STATUS',
            isFixed: true,
            span: 4
        },
        {
            name: '用户姓名/账号',
            value: 'keyword',
            type: 'input',
            isFixed: true,
            span: 4
        }
    ],
    selection: true,
    index: true,
    columns: [
        {
            label: '姓名',
            prop: 'userName',
            type: 'slot'
        },
        {
            label: '账号',
            prop: 'userCode'
        },
        {
            label: '变更类型',
            prop: 'changeTypeName'
        },
        {
            label: '变更详情',
            prop: 'uapUserChangeDetailList',
            type: 'slot',
            minWidth: 300
        },
        {
            label: '当前层级',
            prop: 'currentLevel'
        },
        {
            label: '同步时间',
            prop: 'createTime',
            minWidth: 150
        },
        {
            label: '用户状态',
            prop: 'enableFlag',
            type: 'slot',
            optionsKey: 'LCRM_USER_STATUS'
        },
        {
            label: '处理状态',
            prop: 'processStatus',
            type: 'slot',
            optionsKey: 'LCRM_USER_PROCESSED_STATUS'
        }
    ],
    actions: { // 表格操作列的配置
        fixedWidth: 130, // fixedWidth（可选） 设置操作列的固定宽度，不加该参数默认是按钮list长度*50px
        list: [
            {
                label: '处理',
                event: 'process',
                displayRule: (row) => {
                    // 权限
                    return +row.processStatus === 0 && row.changeType !== 'del' && otherUtils.getHasAuth(btnAuthority.organizationLog.process);
                }
            },
            {
                label: '同意',
                event: 'agree',
                displayRule: (row) => {
                    return +row.processStatus === 0 && row.changeType !== 'del' && otherUtils.getHasAuth(btnAuthority.organizationLog.agree);
                }
            },
            {
                label: '忽略',
                event: 'ignore',
                displayRule: (row) => {
                    return +row.processStatus === 0 && row.changeType !== 'del' && otherUtils.getHasAuth(btnAuthority.organizationLog.ignore);
                }
            }
        ]
    }
};
